import { useFormik, FormikProvider } from 'formik'
import { useState, memo } from 'react'

import { InputField } from '@fields/InputField'
import { useIsMobileXL } from '@hooks/use-media-query'

import { defaultInitialValues as initialValues } from './constants'
import {
  ContentWrapper,
  Wrapper,
  Title,
  ButtonSubmit,
  PersonInfo,
  PersonParagraph,
  InputWrapper,
  InputContainer,
  SubmitedText,
  Subtitle,
} from './styles'
import { validationSchema } from './validationShema'

function ConsultRequestFormComponent({
  title = '',
  subtitle,
  position,
  name,
  submitText,
  inOneLine = false,
  textFont = {},
  maxTitleWidth = null,
  isSmallSubmiteButton = false,
}) {
  const [isSend, setIsSend] = useState(false)

  const formik = useFormik({
    initialValues,
    onSubmit: async ({ email }) => {
      const values = {
        email,
        linkFrom: window.location.pathname,
      }
      setIsSend(true)
      await fetch('/api/consultation', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(values),
      })
    },
    validationSchema,
    validateOnBlur: true,
    validateOnMount: false,
  })

  return (
    <FormikProvider value={formik}>
      <Wrapper onSubmit={formik.handleSubmit}>
        <ContentWrapper>
          {title && (
            <Title maxTitleWidth={maxTitleWidth} as="h2" className="form-title">
              {title}
            </Title>
          )}
          {subtitle && (
            <Subtitle
              send={isSend}
              weight={textFont?.fontWeight}
              fontSize={textFont?.fontSize}
              className="form-subtitle"
            >
              {subtitle}
            </Subtitle>
          )}

          <PersonInfo inOneLine={inOneLine}>
            <PersonParagraph color="white">{name}</PersonParagraph>
            <PersonParagraph color="primary" as="span">
              {position}
            </PersonParagraph>
          </PersonInfo>
          {!isSend ? (
            <InputWrapper
              className="consult-request-form"
              inOneLine={inOneLine}
            >
              <InputContainer>
                <InputField name="email" placeholder="Email" />
              </InputContainer>
              <ButtonSubmit
                isSmallSubmiteButton={isSmallSubmiteButton}
                id="consult-request-btn"
                className="button-submit"
                type="submit"
                label="Send"
              />
            </InputWrapper>
          ) : (
            <SubmitedText>{submitText}</SubmitedText>
          )}
        </ContentWrapper>
      </Wrapper>
    </FormikProvider>
  )
}

export const ConsultRequestForm = memo(ConsultRequestFormComponent)
